<template lang='pug' src='./custom-home-header.pug'></template>

<script>
import HeaderSection from 'components/block/block-header-section/block-header-section'

export default {
  props: ['props'],
  components: {
    HeaderSection
  }
}
</script>



// WEBPACK FOOTER //
// custom-home-header.vue?2645dd0f